export enum Sort {
  Newest = 'newest',
  PriceAsc = 'priceasc',
  PriceDesc = 'pricedesc',
}
